var map = {
	"./skuttle.gif": 724,
	"./slooger.gif": 121,
	"./slooger_2.gif": 623,
	"assets/art/skuttle.gif": 724,
	"assets/art/slooger.gif": 121,
	"assets/art/slooger_2.gif": 623
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 868;